/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown>, weeks: NonNullable<unknown> }} Admin_Subscription_Rights_Freeze_ValueInputs */

const fr_admin_subscription_rights_freeze_value = /** @type {(inputs: Admin_Subscription_Rights_Freeze_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du ${i?.start}, reprise le ${i?.end} (${i?.weeks} sem.)`)
};

/**

* @param {Admin_Subscription_Rights_Freeze_ValueInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_freeze_value = /** @type {((inputs: Admin_Subscription_Rights_Freeze_ValueInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Freeze_ValueInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_freeze_value(inputs)
});